<bpw-menu [showSettings]="false"></bpw-menu>
<div class="container pt-2 pb-3">
  <div class="row">
    <div class="col text-center pt-3">
      <h5 class="text-danger">Die Seite konnte nicht gefunden werden</h5>
    </div>
  </div>
  <div class="row">
    <div class="col text-center pt-2">
      <button type="button" class="btn btn-primary" (click)="navigateToDashboard()">Zurück zum Dashboard</button>
    </div>
  </div>
</div>
